export default "__VITE_ASSET__BxvQ7ije__"